type Proof = { token: string; expires: number };
const key = 'pbl.uploadProofs.v1';
const read = (): Record<string, Proof> => {
  if (typeof window === 'undefined') return {};
  try {
    const value = JSON.parse(window.sessionStorage.getItem(key) || '{}');
    return Object.fromEntries(Object.entries(value).filter(([id, proof]) => {
      const item = proof as Proof;
      return /^\d+$/.test(id) && /^[a-f0-9]{64}$/.test(item?.token) && item.expires > Date.now();
    })) as Record<string, Proof>;
  } catch { return {}; }
};
// 僅在同一瀏覽器工作階段保存能力憑證，供草稿及重新整理後續傳遞。
export const rememberPblUploadProof = (file: { id: number; upload_token?: string; upload_expires_at?: string }) => {
  if (!Number.isSafeInteger(file.id) || !/^[a-f0-9]{64}$/.test(file.upload_token || '')) throw new Error('Upload proof is missing. Please upload the file again.');
  const expires = Date.parse(file.upload_expires_at || '');
  if (!Number.isFinite(expires) || expires <= Date.now()) throw new Error('Upload proof has expired. Please upload the file again.');
  const current = read();
  current[file.id] = { token: file.upload_token!, expires };
  const retained = Object.entries(current).sort((a, b) => b[1].expires - a[1].expires).slice(0, 100);
  window.sessionStorage.setItem(key, JSON.stringify(Object.fromEntries(retained)));
};
export const withPblUploadProofs = <T>(data: T): T => {
  const ids = new Set<string>();
  const visit = (value: unknown, field = '') => {
    if (/(?:^storage_file_id$|_file_id$)/.test(field) && /^\d+$/.test(String(value))) ids.add(String(value));
    if (Array.isArray(value)) value.forEach((item) => visit(item));
    else if (value && typeof value === 'object') Object.entries(value).forEach(([name, item]) => visit(item, name));
  };
  const multipart = typeof FormData !== 'undefined' && data instanceof FormData;
  if (multipart) (data as FormData).delete('upload_tokens');
  if (multipart) (data as FormData).forEach((value, name) => visit(value, name));
  else visit(data);
  const stored = read();
  const selected = Object.fromEntries(Array.from(ids).filter((id) => stored[id]).map((id) => [id, stored[id].token]));
  if (Object.keys(selected).length === 0) return data;
  if (multipart) { (data as FormData).set('upload_tokens', JSON.stringify(selected)); return data; }
  return { ...data, upload_tokens: selected };
};
